/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Components/GenericKubernetesResourceValidationDialog" />
import * as React from "react";
import { IVssComponentContext, VssComponent, IVssLayoutManager } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import * as Resources from "Environments/ProviderCreateDetails/Kubernetes/Resources";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IGenericKubernetesResourceValidationDialogProps {
    message: string;
    onContinue: () => void;
    onDismiss: () => void;
}

class GenericKubernetesResourceValidationDialog extends VssComponent<IGenericKubernetesResourceValidationDialogProps> {
    public render(): React.ReactNode {
        return <Dialog
            lightDismiss={false}
            modal={true}
            titleProps={{ text: Resources.ValidationDialogHeader }}
            footerButtonProps={[
                {
                    text: Resources.ContinueAnywayButton,
                    onClick: () => this.props.onContinue()
                },
                {
                    text: Resources.StopButton,
                    primary: true,
                    onClick: () => this.props.onDismiss()
                }
            ]}
            onDismiss={() => this.props.onDismiss}        >
            <div className="text-m" style={{ marginBottom: 15 }}>{Resources.ValidationDialogMessage}</div>
            <div className="text-m">{this.props.message}</div>
        </Dialog>
    }
}

export function renderGenericKubernetesValidationDialog(pageContext: IVssPageContext, message: string, onContinue: () => void, onCancel: () => void): void {
    pageContext.getService<IVssLayoutManager>("IVssLayoutManager").renderCallout((onDismiss: () => void) => {
        return <GenericKubernetesResourceValidationDialog
            message={message}
            onContinue={() => {
                onContinue();
                onDismiss();
            }}
            onDismiss={() => {
                onCancel();
                onDismiss();
            }}
        />
    })
}
